module.exports = __webpack_public_path__ + "static/media/listing-page-kasauli.18886c91.webp";